<div class="w-full h-full">
    <div class="flex items-center justify-between space-x-3 pt-9 text-sm">
        <div class="flex items-center space-x-3 text-xs"></div>
        <div class="flex items-center space-x-3 text-xs"></div>
    </div>
    <div class="w-700-px mx-auto">
        <form [formGroup]="pushNotifForm">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 space-y-5">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-60-px font-semibold">
                            Title:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" type="text" placeholder="Title" formControlName="title">
                    </div>
                    
                    <div class="card-input flex items-start text-xs py-2 w-full">
                        <span class="text-xs w-110-px font-semibold">
                            Message:
                        </span>
                        <textarea formControlName="message" class="placeholder-black focus:outline-none w-full h-70-px bg-gray-100 rounded-md pl-3 resize-none italic" placeholder="Message" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                    <div class="w-full flex flex-row justify-between gap-4">
                        <div class="flex flex-row justify-between w-full">
                            <div class="flex flex-col space-x-3 text-xs font-semibold flex-1">
                                <div class="mb-2 flex flex-row gap-2">
                                    <span>Cover Image: </span>
                                    <input formControlName="coverImage" type='file' class="hidden" (change)="onSelectFileCover($event)" #coverImgInitial>
                                    <button type="button" class="browse-btn px-4 py-2 focus:outline-none" (click)="coverImgInitial.click()">
                                        Browse...
                                    </button>
                                </div>
                                <div *ngIf="cover_img"  class="w-300-px b-violet">
                                    <img 
                                        *ngIf="cover_img" 
                                        [src]="cover_img" 
                                        class="w-full h-200-px object-contain" 
                                        alt="Cover Image"
                                    >
                                </div>
                            </div>

                            <div class="flex flex-col space-x-3 text-xs font-semibold flex-1">
                                <div class="mb-2 flex flex-row gap-2">
                                    <span>Featured Image: </span>
                                    <input formControlName="featureImage" type='file' class="hidden" (change)="onSelectFileFeatured($event)" #featureImgInitial>
                                    <button type="button" class="browse-btn px-4 py-2 focus:outline-none" (click)="featureImgInitial.click()">
                                        Browse...
                                    </button>
                                </div>
                                <div *ngIf="feature_img" class="w-300-px b-violet">
                                    <img 
                                        *ngIf="feature_img" 
                                        [src]="feature_img" 
                                        class="w-full h-200-px object-contain" 
                                        alt="Featured Image"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="w-full flex items-center justify-center mt-6 mb-4 space-x-3">
        <button 
            [disabled]="isSubmitDisabled()" 
            [matTooltip]="isSubmitDisabled() ? 'Nothing to reset here' : ''"
            [ngClass]="isSubmitDisabled() ? 'cursor-not-allowed opacity-70 btn-disabled-white' : 'btn-white-orange'"
            (click)="reset()" class="uppercase custom-btn font-bold text-xs px-6 py-2"
        >
            Reset
        </button>
        <button 
            [disabled]="isSubmitDisabled()" 
            [matTooltip]="isSubmitDisabled() ? 'Please fill up first' : ''"
            [ngClass]="isSubmitDisabled() ? 'bg-gray-400 cursor-not-allowed opacity-70' : 'btn-dark-orange'" 
            (click)="store()" 
            class="uppercase custom-btn font-semibold text-xs px-6 py-2"
        >
            Submit
        </button>
    </div>
    <div class="overlay-trigger-scope">
        <!-- Table Controls Component -->
        <app-table-controls
            [class.pointer-events-none]="!showTable"
            [currentLimit]="size"
            [searchPlaceholder]="'Search push notifications'"
            (limitChangeEvent)="onLimitChangeFromComponent($event)"
            (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
            (keydownEvent)="keyDownFunction($event)"
        ></app-table-controls>
    
        <!-- Table Section with Blur Overlay -->
        <div class="relative">
            <div
                *ngIf="!showTable"
                class="absolute top-0 left-0 right-0 z-10 flex items-center justify-center bg-light-orange"
                style="height: 10vh; min-height: 300px;"
            >
                <div class="flex items-center justify-center px-6 py-4 rounded-lg backdrop-blur-md bg-white/30">
                    <button
                        *ngIf="!isTableLoading"
                        (click)="showTableData()"
                        class="btn-expand--pulse uppercase custom-btn btn-white-orange
                            font-semibold text-sm px-5 py-2 shadow-lg
                            hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                    >
                        See Table
                    </button>
    
                    <app-megapay-loader *ngIf="isTableLoading"></app-megapay-loader>
                </div>
            </div>
    
            <!-- Table Container -->
            <div *ngIf="showTable">
                <!-- Data Table Component -->
                <app-data-table
                    [tableHeader]="tableHeader"
                    [tableSubHeader]="tableSubHeader"
                    [isLoading]="isLoading"
                    [sort_type]="sort_type"
                    (toggleOnSort)="sortList($event.key, $event.type)"
                >
                    <tr class="focus:outline-none" *ngFor="let pushNotif of pushNotif_lists">
                        <td>{{ pushNotif.createDate | date:'yyyy-dd-MM' | nullWithDefault }}</td>
                        <td>{{ pushNotif.title | nullWithDefault | titlecase }}</td>
                        <td>{{ pushNotif.message | nullWithDefault }}</td>
                        <td>
                            <a [href]="pushNotif.notifCoverImageUrl" *ngIf="pushNotif.notifCoverImageUrl">
                                <img [src]="pushNotif.notifCoverImageUrl" style="width:100px" alt="Cover image">
                            </a>
                            <span *ngIf="!pushNotif.notifCoverImageUrl">N/A</span>
                        </td>
                        <td>
                            <a [href]="pushNotif.notifFeatureImageUrl" *ngIf="pushNotif.notifFeatureImageUrl">
                                <img [src]="pushNotif.notifFeatureImageUrl" style="width:100px" alt="Feature image">
                            </a>
                            <span *ngIf="!pushNotif.notifFeatureImageUrl">N/A</span>
                        </td>
                        <td>{{ pushNotif.totalCount | nullWithDefault }}</td>
                        <td>{{ pushNotif.viewCount | nullWithDefault }}</td>
                        <td class="text-xs">
                            <div class="flex items-center space-x-3">
                                <ng-container *ngIf="pushNotif">
                                    <button class="power-btn2 active" *ngIf="pushNotif.status === 0" (click)="disable(pushNotif.uid, 1)">
                                        Enabled
                                    </button>
                                    <button class="power-btn2" *ngIf="pushNotif.status === 1" (click)="enable(pushNotif.uid, 0)">
                                        Disabled
                                    </button>
                                </ng-container>
                                <button class="action-btn-blue2 custom-btn" [routerLink]="['/features/push-notification/push-notification-edit/'+pushNotif.uid]">
                                    Edit
                                </button>
                            </div>
                        </td>
                    </tr>
                </app-data-table>
    
                <!-- Pagination Component -->
                <app-pagination
                    [currentPage]="current_page"
                    [totalPages]="total_pages"
                    [pageSize]="size"
                    [totalItems]="total"
                    (pageChange)="setPage($event)"
                    (previousPage)="prevPage()"
                    (nextPage)="nextPage()"
                    showTotalEntries="true"
                ></app-pagination>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>